export const COLUMNS_NAME = {
    SUPPLIER:'Supplier',
    ADDRESS:'Address',
    TEL:"Tel ",
    INVOICE_NUMBER:"Invoice Code",
    REMARKS:"Remarks",
    GRN_NUMBER:"GRN Number",
    INVOICE_DATE:"Date",
    GRN_DATE:"GRN Date",
    LOCATION:"Location",
    CODE:"Code",
    DESCRIPTION:"Description",
    BARCODE:"Barcode",
    UNIT_PRICE:"U.Price",
    QUANTITY:"QTY",
    DISCOUNT_PERCENTAGE:"Dis(%) ",
    DISCOUNT_AMOUNT:"Dis(Rs)",
    SUM:"Sum",
    SUB_TOTAL:"Sub Total",
    BILL_DISCOUNT_PERCENTAGE:"Bill Discount",
    BILL_DISCOUNT_AMOUNT:"Bill Discount (Rs)",
    TOTAL:"Total",
    INVOICE_TOTAL:"Invoice Total",
    RECEIVED_BY:"Received by",
    CHECKED_BY:"Checked by",
    AUTHERIZED_SIGNATURE:"Authorized Signature",
    RECEIPT_CODE:"Receipt Code",
    DATE:"Date",
    PAYEMENT_TYPE:"Payment Type",
    AMOUNT:"Amount",
    CHEQUE_NO:"Cheque No",
    BANK_NAME:"Bank Name",
    BRANCH_CODE:"Branch Code",
    DEPOSIT_DATE:"Deposit Date",
    CARD_NO:"Card No",
    REFERANCE_NO:"Referance No",
    SETTELED_AMOUNT:"Settle Amt",
    TOTAL_AMOUNT:"Total Amt",
    OUTSTANDING:"Outstanding",
    VOUCHER_NO:"Voucher No",
    CUSTOMER_NAME:"Customer",
    OVERPAYMENT:"Over Payment",
    CHEQUE_RETURN_AMOUNT:"Cheque Return Amount",
    QUOTATION_NO:"Quatation No:",
    SALESREP: "Sales Rep",
    RETURNAMOUNT:"Return Amount",
    CREDITAMOUNT:"Credit Amount",
    LAST_TOTAL:"TOTAL",
    DISCOUNT_TOTAL:"Discount Total",
    RETURN_NO:"Return No",
    RETURN_DATE:"Return Date",
    PREPAIRED_BY:"Prepared by",
    CUSTOMER_CODE:"Customer Code",
    DISCOUNT:"Dis",
    PAYID_AMOUNT:"Paid Amount",
    NAME:"Name",
    TYPE:"Type",
    CATEGORY:"Category",
    LOCATION_CODE: "Location Code",
    BILL_DISCOUNT:"Bill Discount",
    LINE_DISCOUNT:"Line Discount",
    RETAIL_PRICE:"Ret.Pr",
    COST_PRICE:"Co.Pr",
    DEBIT_BALANCE:"Debit Balance",
    RETrUN_CODE:"Return Code",
    FROM:"From ",
    TO:"To ",
    VEHICLE_NO:"Vehicle No:",
    VEHICLE_TYPE:"Vehicle Type:",
    VEHICLE_BRAND:"Vehicle Brand:",
    SERIVE_PACK:"Service Pack",
    METER_READING:"Current Meter Reading",
    PAYMENT_RECIEVED:" Payment Recieved",
     BALANCE_GIVEN:"Balance Given",
     CUSTOMER_ACCEPTANCE:"Customer Acceptance",
     PRE_OUTSTANDING:"Pre-Oustanding",
     SETTLED_TOTAL: "Settled Total",
     PO_NUMBER:"P.O Number",
     WARRANTY_PERIOD:"Warranty",
     CUSTOM_CODE:"Custom Code",
     REMAINING_QUNATITY: "Remaining Quantity",
     REFEREES: "Referees",
     UNIT_SOLD_PRICE:"Sold Price",
     ACC_TRANSACTION_CODE:"Transection Code",
     ACC_TRANSACTION_TYPE:"Transection Type",
     CREDIT_OR_DEBIT: "Credit or Debit",
     NEXT_SERVICE_DATE: "Next Service Date",
     NEXT_SERVICE_KM:"Next Service KM",
     TOTAL_OUTSTANDING : "Total Outstanding",
     DEBIT:"Debit (+)",
     CREDIT:"Credit (-)",
     BALANCE:"Balance",
     SALESREP_CODE:"Sales Rep Code",
     ROUT_NAME:"Route Name",
     SERIES_CODE:"Series",
     TRANSACTION_TYPE:"Transection Type",
     ENTRY_TYPE:"Entry Type",
     LEDGER_TYPE:"Ledger Type",
     TRANSACTION_MODE:"Transection Mode",
     TRANSACTION_NAME : "Transection Name",
     CHEQU_RETURN:"Cheque Return",
     CASH_AMOUNT:"Cash Amount",
     CHEQUE_AMOUNT:"Cheque Amount",
     REFERANCE_NAME:"Referance Name",
     STOCK_IN_TYPE:"Stock in type",
     BATCH_NO:"Batch No",
     EXPENSE_CATEGORY:"Expense Category",
     EXPENSE_TYPE:"Expanse Type",
     ITEM_CODE:"Item Code",
     PREVIOS_OUTSTANDING : "Previous Outtstanding",
     WHOLESALE_PRICE:"W/S Pr",
     MIN_STOCK:"Min Stock",
     MAX_STOCK:"Max Stock",
     ACCESS:"Access",
     ACTION:"Action",
     SOURSE:"Sourse",
     TOTAL_QUANTITY:"Total QTY",
     CURRENT_LOCATION_QUANTITY:"Current Location QTY",
     TOTAL_IN_COST_PRICE:"Total-Cost",
     USER:"User",
     OUTSTANDING_WITH_CHEQUE_RETURN:"Outstanding With Cheque Return",
     STATUS:"Status",
     ONLINE_TRANSFER:"Online Payment",
     OVER_PAYMENT:"Over payment",
     RETURN_AMOUNT:"Return Amount",
     GRN_TOTAL:"Grn Total",
     RECEIPT_OVERPAYMENT:"Receipt Overpayment",
     CHEQUE_PAYMENT:"Cheque Payment",
     RECEIPT_TOTAL:"Receipt Total",
     ACCES_AMOUNT:"Acces Amount",
     BANK_DEPOSIT:"Bank Deposit",
     CARD_PAYMENT:"Card Payment",
     CASH_PAYMENT:"Cash payment",
     FREEZ_STATUS : "Freez Status",
     NUMBER_OF_ITEM:"No of item",
     NUMBER_OF_QUANTITY:"No of qty",
     TOTAL_PROFIT:"Total Profit",
     STOCK_ISSUE_TYPE: "Type",
     AREA_SALES_MANAGER:"Area Sales Manager",
     DRIVER:"Driver",
     NET_UNIT_PRICE:"Net U.Price",
     PAY_OFF:"Pay Off",
     PAYMENT_DATE:"Payment Date",
    PAYMENT_OPTIONS: "Paymet Options",
    RETURN_CHEQUE_PAYMENT: "RTN Cheque Payment",
    RTN_PAYMENT_STS:"RTN PAY STS"
    
    
        
    
        
    
    
    
    
    
    
        
    
    




    

    






    
}